'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wixAxiosInstanceConfig = exports.wixAxiosConfig = undefined;

var _wixAxiosConfig = require('./src/wix-axios-config');

var _wixAxiosConfig2 = _interopRequireDefault(_wixAxiosConfig);

var _wixAxiosInstanceConfig = require('./src/wix-axios-instance-config');

var _wixAxiosInstanceConfig2 = _interopRequireDefault(_wixAxiosInstanceConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.wixAxiosConfig = _wixAxiosConfig2.default;
exports.wixAxiosInstanceConfig = _wixAxiosInstanceConfig2.default;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ../~/wix-axios-config/dist/index.js
// module id = 335
// module chunks = 0